import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { compose } from 'recompose'
//import { FormattedMessage } from 'react-intl'

import Logo from './Logo'
import Link from './Link'
import {PERMISSIONMENU} from './MenuComponents/getMenu'

import { YMInitializer } from 'react-yandex-metrika';

const Header = ({data = {}, role, isDisable, onOpenCountrySelect, verticalScroll, onOpenSigin, onOpenSearch, isIndex, handleMenuOpen, openClaim, openSettings, isLogged, user, abtest, logOut, modalState, setModalState }) => {
  const header = classNames({
    'Header': true,
    'Header_disable': isDisable
  })
  //объявление динамических компонетов меню
  const RightSide = PERMISSIONMENU[role].rightSide;
  const Menu = PERMISSIONMENU[role].menu;
  return (
    <div>
	  <YMInitializer accounts={[64333339]} options={{webvisor: true}} version="2"/>
      <div className={header}>
        <div className='Header__bg' />
        <div className='Header__body'>
          <button className='Burger' type='button' onClick={handleMenuOpen}>
            <span className='Burger__line' />
            <span className='Burger__line' />
            <span className='Burger__line' />
          </button>
          <Menu data={data}/>
          <div className='Header__logo'>
            { isIndex
              ? <span className='Header__logo-img'><Logo /></span>
              : <Link to='/' className='Header__logo-img'><Logo /></Link>
            }
          </div>
          <RightSide
            user={user}
            openClaim={openClaim}
            onOpenCountrySelect={onOpenCountrySelect}
            data={data}
            abtest={abtest}
            isLogged={isLogged}
            logOut={logOut}
            onOpenSearch={onOpenSearch}
            onOpenSigin={onOpenSigin}
            openSettings={openSettings}
          />
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = ({ contacts }) => ({ ...contacts });

export default compose(
  connect(mapStateToProps),
)(Header)



// WEBPACK FOOTER //
// ./src/components/Header.jsx